module.exports = __webpack_public_path__ + "img/logo.b1fc469f.png";